import React, { ReactNode } from 'react';
import { BorderPanel } from '../../components/layout/borderpanel';
import { ModalPaddingType } from './Modal';
import { VerticalPanel } from '../../components/layout/verticalpanel';

export interface ModalContentProps {
   header?: ReactNode;
   footer?: ReactNode;
   padding: ModalPaddingType;
   children?: ReactNode;
   scroll?: boolean;
   className?: string;
   style?: React.CSSProperties;
}

export const ModalContent = (props: ModalContentProps) => {
   const scroll = props.scroll === undefined ? true : props.scroll;

   return (
      <BorderPanel
         top={props.header}
         bottom={props.footer}
         className={`uf-modal-content-container-outer-panel ${props.className}`}
         minHeight={'inherit'}
         style={props.style}
      >
         <VerticalPanel scroll={scroll} padding={props.padding} className={`uf-modal-content-container`}>
            {props.children}
         </VerticalPanel>
      </BorderPanel>
   );
};
